export default "__VITE_ASSET__h6dqagfQ__"